import React from 'react'
import { ButtonCircle } from '../ButtonCircle'

export const Categories = ({item,onClick}) => {

    
    return (
        <div className="w-full mx-auto lg:p-6 my-2 h-[90%]">
            <h4 className="text-center font-semibold mb-6">{item.categories.title}</h4>
            <div className="grid grid-cols-4 gap-4 ">
                {item.categories.items.slice(0, 8)?.map((p,index) => (
                    <ButtonCircle key={index} item={p}  onClick={onClick} />
                ))}
            </div>
        </div>
    )
}
